import React from 'react';
import { IndigoAppContextType } from 'app/AppContext';
import Column from 'widgets/blotter/columns/Column';
import ColumnType from 'widgets/blotter/columns/ColumnType';

export const labelFunctionCellRenderer =
    <C extends ColumnType>(context: IndigoAppContextType, column: Column<C>) =>
    // eslint-disable-next-line react/display-name
    <T,>(props: { value: T }) =>
        props.value !== undefined ? (
            <span>{column.labelFunction!(context, props.value)}</span>
        ) : (
            <span />
        );

export const labelFunctionCellExport =
    <C extends ColumnType>(context: IndigoAppContextType, column: Column<C>) =>
    <T,>(value: T) =>
        value !== undefined ? column.labelFunction!(context, value) : '';
